"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.HelperText = void 0;
const react_1 = __importStar(require("react"));
const helper_text_styles_1 = require("./helper-text.styles");
require("./helper-text.types");
exports.HelperText = (0, react_1.memo)(({ children, status = 'default', message, messagePosition = 'down', noMargin, className, testId = 'helperText', }) => {
    return (react_1.default.createElement("div", { className: className },
        messagePosition === 'down' && children,
        react_1.default.createElement(helper_text_styles_1.StyledMessage, { status: status, noMargin: noMargin && !message, messagePosition: messagePosition, "data-testid": `${testId}.message` }, message),
        messagePosition === 'up' && children));
});
